import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationChannelTypeResource {
  
  static getReservationChannelTypes(queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/channel_types.json" + q).
      done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

}
export default SMReservationChannelTypeResource;


// WEBPACK FOOTER //
// ./app/javascript/resources/SMReservationChannelTypeResource.js